exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-interest-confirmed-___style__inviteContainer___3Poyg{text-align:center}.web-flows-interest-confirmed-___style__inviteContainer___3Poyg>img{border-radius:50%;width:50px;height:50px}.web-flows-interest-confirmed-___style__inviteContainer___3Poyg>h2{font-weight:400;border-bottom:none;padding-bottom:1em;padding-top:1em}.web-flows-interest-confirmed-___style__messages___2RK2f{border-bottom:1px solid #e5e3e3;border-top:1px solid #e5e3e3;padding:2em 0}.web-flows-interest-confirmed-___style__transfer___2erAg{font-size:1.1em;color:#585858;margin-bottom:.3em;margin-top:0;margin-bottom:0}.web-flows-interest-confirmed-___style__limited___3Ir3K{font-size:11pt;color:#ad2015;margin-top:.3em;margin-bottom:0}.web-flows-interest-confirmed-___style__logout___1CebT{text-align:center;margin-bottom:0;color:#95989a}", ""]);

// exports
exports.locals = {
	"inviteContainer": "web-flows-interest-confirmed-___style__inviteContainer___3Poyg",
	"messages": "web-flows-interest-confirmed-___style__messages___2RK2f",
	"transfer": "web-flows-interest-confirmed-___style__transfer___2erAg",
	"limited": "web-flows-interest-confirmed-___style__limited___3Ir3K",
	"logout": "web-flows-interest-confirmed-___style__logout___1CebT"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/interest/confirmed/style.css
// module id = 1354
// module chunks = 0